
<template>
  <div style="margin-left:50px;">

    <el-form style="display: flex;flex-wrap: wrap;">

        <el-form-item label="方案名称:" style="display: flex;width: 33%;" >
            <!-- <el-select
                placeholder="请选择方案名称"
                v-model="coursecancellationStatusInput"
                style="width: 100%"
                clearable
                filterable >
                <el-option
                v-for="item in coursecancellationStatus"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select> -->
            <el-input v-model="input1" placeholder="请输入方案名称"></el-input>
        </el-form-item>


        <el-form-item label="任务名称:" style="display: flex;width: 33%;">
            <!-- <el-select
                placeholder="请选择任务名称"
                v-model="student"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                v-for="item in getStudentsArr"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select> -->
            <el-input v-model="input2" placeholder="请输入任务名称"></el-input>
        </el-form-item>

        <el-form-item label="任务审批人:" style="display: flex;width: 33%;" >
            <el-select
                placeholder="请选择任务审批人"
                v-model="student_s"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                v-for="item in getStudentsArr_s"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>



        <!-- <el-form-item label="日期:" style="display: flex;width: 33%;"  label-width="75px">
            <el-date-picker
            style="width: 104%;margin-left: -139px;"
            v-model="dateTimeList"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable>
            </el-date-picker>
        </el-form-item> -->

        <el-form-item label="任务审批状态:" style="display: flex;width: 33%; margin-left: -29px; margin-right: 14px;" >
            <el-select
                placeholder="请选择审核状态"
                v-model="coursecancellationStatusInput_s"
                style="width: 100%"
                clearable
                filterable >
                <el-option
                v-for="item in coursecancellationStatusss"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="参训人完成状态:" style="display: flex;width: 33%; margin-left: -19px;margin-right: 14px;" >
            <el-select
                placeholder="请选择参训人完成状态"
                v-model="coursecancellationStatusInput_sss"
                style="width: 100%"
                clearable
                filterable >
                <el-option
                v-for="item in coursecancellationStatuss"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="提交人:" style="display: flex;width: 33%;" >
            <el-select
                placeholder="请选择提交人"
                v-model="coursecancellationStatusInput_ss"
                style="width: 100%"
                clearable
                filterable >
                <el-option
                v-for="item in coursecancellationStatus"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>

        
        <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
        </div>

    </el-form>


    <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="400">
        <!-- <el-table-column prop="courseDate" label="日期">
          <template slot-scope="scope">
             <span>{{scope.row.courseDate.substring(0,10)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="trainName" label="方案名称"></el-table-column>
        <el-table-column prop="teacherName" label="提交人"></el-table-column>
        <el-table-column prop="numberDays" label="所属天数"></el-table-column>
        <el-table-column prop="taskName" label="任务名称"></el-table-column>
        <el-table-column prop="auditName" label="任务审批人"></el-table-column>
        <el-table-column prop="auditStatus" label="任务审批状态">
            <template slot-scope="scope">
              <div v-if="scope.row.auditStatus === '-1' ">已驳回</div>
              <div v-if="scope.row.auditStatus === '-2' ">待提交</div>
              <div v-if="scope.row.auditStatus === '0' ">审批中</div>
              <div v-if="scope.row.auditStatus === '1' ">已审批</div>
              <div v-if="scope.row.auditStatus === '2' ">未通过</div>
            </template>
        </el-table-column>
        <el-table-column prop="teacherPerformance" label="参训人完成状态">
            <template slot-scope="scope">
              <div v-if="scope.row.teacherPerformance === '1' ">未完成</div>
              <div v-if="scope.row.teacherPerformance === '2' ">已完成</div>
              <div v-if="scope.row.teacherPerformance === '3' ">未通过</div>
            </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-around;">
                <!-- <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button> -->
                <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
              </div>
            </template>
        </el-table-column>
      </el-table>



    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
    </el-pagination>



    <el-dialog :title="ShowDlongTitle" :visible.sync="ShowDlong" :before-close="commitCler">
        
        <!-- <el-form ref="form" :model="form" label-width="90px"> -->
         <el-form ref="form"  label-width="90px" style=" display: flex; flex-wrap: wrap;">
            <el-form-item label="方案名称:" style="text-align: start; width: 45%;margin-left: 10px;" class="disable-click">
                <!-- <div style="text-align: start;">{{resData.trainName }}</div> -->
                <el-input v-model="resData.trainName" placeholder="请输入内容"></el-input>
            </el-form-item>
            <!-- <el-divider></el-divider> -->

            <el-form-item label="提交人:" style="text-align: start;width: 45%; margin-left: 35px;" class="disable-click">
               <!-- <div style="text-align: start;">{{resData.teacherName}}</div> -->
               <el-input v-model="resData.teacherName" placeholder="请输入内容"></el-input>
            </el-form-item>
            <!-- <el-divider></el-divider> -->

           <el-form-item label="相关资料:" style="text-align: start;width: 45%;margin-left: 10px;">
            <div style="text-align: start;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">
                <a style="margin-right: 10px;display: block;" v-for="(itme,index) in resData.taskData" :key="index" :href="itme.url">{{ itme.name }}</a>
            </div>
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="提交日期:" style="text-align: start;width: 45%;margin-left: 35px;" class="disable-click">
               <!-- <div style="text-align: start;">{{resData.createTime }}</div> -->
               <el-input v-model="resData.createTime" placeholder="请输入内容"></el-input>
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="参训人姓名:" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click"> 
               <!-- <div style="text-align: start;">{{resData.teacherName }}</div> -->
               <el-input v-model="resData.teacherName" placeholder="请输入内容"></el-input>
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="任务名称:" style="text-align: start;width: 45%;margin-left: 35px;" class="disable-click">
               <!-- <div style="text-align: start;">{{ resData.taskName  }}</div> -->
               <el-input v-model="resData.taskName" placeholder="请输入内容"></el-input>
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="总结内容:" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click">
               <!-- <div style="text-align: start;">{{ resData.summarize  }}</div> -->
               <el-input v-model="resData.summarize" placeholder="请输入内容"></el-input>
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="相关链接:" style="text-align: start;width: 45%;margin-left: 35px;">
                <div style="text-align: start;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">
                    <a style="margin-right: 10px;display: block;" v-for="(itme,index) in resData.auditData " :key="index" :href="itme.url">{{ itme.name }}</a>
                </div>
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="取消原因:" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click">
               <!-- <div style="text-align: start;">{{ resData.cancelCause  }}</div> -->
               <el-input v-model="resData.cancelCause" placeholder="请输入内容"></el-input>
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="审批状态:" style="text-align: start;width: 45%;margin-left: 35px;" class="disable-click">
               <div style="text-align: start;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">{{ resData.auditStatus === '-2'? '待提交' :  resData.auditStatus === '-1' ? '已驳回' :  resData.auditStatus === '0' ? '审批中' : resData.auditStatus === '1' ? '已审批' : '未通过' }}</div>
               <!-- <el-input v-model="resData.cancelCause" placeholder="请输入内容"></el-input> -->
           </el-form-item>
           <!-- <el-divider></el-divider> -->

           <el-form-item label="" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click" v-if="resData.auditOpinion">
               <!-- <div style="text-align: start;">{{ resData.cancelCause  }}</div> -->
           </el-form-item>

           <el-form-item label="审批意见:" style="text-align: start;width: 45%;margin-left: 36px;" class="disable-click" v-if="resData.auditOpinion">
               <!-- <div style="text-align: start;">{{ resData.cancelCause  }}</div> -->
               <el-input v-model="resData.auditOpinion"  show-word-limit :autosize="{ minRows: 6, maxRows: 6  }"></el-input>
           </el-form-item>


        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitCler">取消</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitAdd('NotPassedes')">未通过</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" :disabled=" resData.auditStatus !== '0'"  @click="commitAdd('No')">驳回</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" :disabled=" resData.auditStatus !== '0'"  @click="commitAdd('Yes')">通过</el-button>
        </div>

    </el-dialog>
    


    <el-dialog title="添加培训任务" style="padding: 0px 10px;" :visible.sync="AddShowDlong" :before-close="AddcommitCler">
        
        <el-form ref="form" :model="form" label-width="100px">

            <el-form-item label="培训名称:">
                <el-input placeholder="请选择培训名称" v-model="Addform.TrainName" style="width: 100%" clearable> 
                </el-input>
            </el-form-item>

            <el-form-item label="任务创建人:">
              <el-select
                placeholder="请选任务创建人"
                v-model="Addform.CreatorName"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                    v-for="item in getStudentsArr_s"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname">
                </el-option>
            </el-select>
            </el-form-item>

           <el-form-item label="参加培训人:">
            <el-select
                placeholder="请选择参加培训人"
                v-model="Addform.TrainerName"
                style="width: 100%"
                clearable
                filterable>
                 <el-option
                     v-for="item in coursecancellationStatus"
                     :key="item.id"
                     :value="item.id"
                     :label="item.realname" >
                 </el-option>
            </el-select>
           </el-form-item>

           <el-form-item label="培训内容:">
                <div style="width: 100%;height: 250px;overflow-x: auto;display: flex;">
                    <el-radio  @click="clickitem(item.id)" border v-model="Addform.TrainingContent"
                         style="width: 130px; height: 100%;" v-for="(item, index) in planArr" :key="index" :label='item.id'>
                        <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
                        <div style="text-align: left;"  v-for="(item1, index1) in item.planList" :key="index1">
                            <p>课节数:{{ item1.classNum }}</p>
                            <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
                        </div>
                    </el-radio>
                </div>
           </el-form-item>

           <el-form-item label="资料上传:">
                <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :on-remove="handleRemove"
                    :beforeUpload="beforeUpload"
                    :http-request="handleUpload"
                    :on-error="handleError"
                    :auto-upload="true"
                    show-file-list
                    :file-list="fileDataList"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
           </el-form-item>   

           <el-form-item label="审批人:">
                <el-select
                    placeholder="请选择审批人"
                    v-model="Addform.ApprovedName"
                    style="width: 100%"
                    clearable
                    filterable >
                    <el-option
                        v-for="item in coursecancellationStatus"
                        :key="item.id"
                        :value="item.id"
                        :label="item.realname" >
                    </el-option>
                </el-select>
           </el-form-item>


        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="AddcommitCler">取消</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSub">保存</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddcommitAdd">提交</el-button>
        </div>

    </el-dialog>



    <el-dialog title="审批意见" style="padding: 0px 10px;" :visible.sync="ShowapprovalOpinions" :before-close="approvalOpinionsCler">
        <el-input :autosize="{  minRows: 6, maxRows: 6 }"  type="textarea"  placeholder="请输入内容"  v-model="approvalOpinionstextarea" maxlength="200" show-word-limit></el-input>
    
        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions">确定</el-button>
        </div>

    </el-dialog>


    <el-dialog title="审批意见" style="padding: 0px 10px;" width="30%" :visible.sync="ShowapprovalOpinions_Yes" :before-close="approvalOpinionsCler_Yes">
        
        <div style="">是否提交审批意见?</div>

        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="approvalOpinionsCler_Yes">取消</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions_Yes">确定</el-button>
        </div>

    </el-dialog>






</div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import Vue from 'vue';
import { ref, reactive, onMounted, defineComponent, toRefs, nextTick, onUpdated, watchEffect } from '@vue/composition-api'
var $Vue = Vue.prototype
import {  getStudentsType } from "@/api/fiveClassApi"
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import { isReturn } from "../utils/retnue";
import { getTeachers } from "@/api/feedBackApi";
export default defineComponent({

    setup(props, { attrs, slots, emit, expose }){
        let coursecancellationStatusInput_sss =  ref('')
        let input1 = ref('')
        let input2 = ref('')
        let taskId = ref('')
        let approvalOpinionstextarea = ref('')
        let ShowapprovalOpinions = ref(false)
        let getStudentsArr = ref([])
        let getStudentsArr_s = ref([])
        let coursecancellationStatus = ref([])
        let coursecancellationStatuss = ref([])
        let student = ref('')
        let student_s = ref('')
        let coursecancellationStatusInput = ref('')
        let coursecancellationStatusInput_s = ref('')
        let coursecancellationStatusInput_ss = ref('')
        let dateTimeList = ref([])
        let dataList = ref([])
        let requestParameters = reactive({pageSize:10,total:0,pageNum:1})
        let ShowDlong = ref(false)
        let ShowDlongDisabled = ref(false)
        let ShowDlongTitle = ref('编辑')
        let form = reactive({ student:'', student_s: '', coursecancellationStatusInput:[], dateTimeList: '' })
        let AddShowDlong = ref(false)
        let Addform = reactive({ TrainName:'', CreatorName:'', TrainerName: '', TrainingContent:'', DataUpload: '', ApprovedName: '' })
        let planArr = ref([])
        let fileDataList = ref([])
        let ShowapprovalOpinions_Yes = ref(false)
        let coursecancellationStatusss = ref([])
        let valueAuditStatus = ref(0)

        let resData = reactive({ })

        onMounted(()=>{
            handleAllApi()
        })

        watchEffect(() => {
           
        })


        const handleInit = () =>{
            let data = { 
                pageNum: requestParameters.pageNum,
                pageSize: requestParameters.pageSize,
                trainName: input1.value,
                teacher: coursecancellationStatusInput_ss.value,
                taskName: input2.value,
                auditId: student_s.value,
                auditStatus: coursecancellationStatusInput_s.value,
                teacherPerformance: coursecancellationStatusInput_sss.value,
            }
            axios.post(`${apiBaseUrl}/trainTask/findAuditPage`, data,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })
        }


        const handleAllApi = () =>{
            getStudentsArr.value = [{ id: 1, realname : '李四' },{ id: 2, realname : '张三' },{ id: 3, realname : '王五' }]
            getStudentsArr_s.value = [{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }]
            coursecancellationStatuss.value = [{ id: 1, realname : '未完成' },{ id: 2, realname : '已完成' },{ id: 3, realname : '未通过' }]
            coursecancellationStatusss.value = [{ id: -2, realname : '待提交' },{ id: 0, realname : '审批中' },{ id: 1, realname : '已审批' },{ id: -1, realname : '已驳回' },{ id: 2, realname : '未通过' }]
            // dataList.value = [{ courseDate: '2024-01-14', courseStartTime: '张三', courseEndTime: '颇多野', subjectName: [{url:'https:baidu.com',name:'虚拟图片'},{url:'https:baidu.com',name:'虚拟图片2'}]  }]

            axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  getStudentsArr.value = res.data.data
                  getStudentsArr_s.value = res.data.data
                //   coursecancellationStatus.value  = res.data.data
              }).catch(error => {
                console.error(error)
            })

            getTeachers().then(res => {
                coursecancellationStatus.value  = res.data
            })

            handleInit()

            axios.post(`${apiBaseUrl}/contract/getList`, requestParameters,{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            }).then(res => {
                isReturn(res.code)
                planArr.value = res.data.data.records
            }).catch(error => {
                console.error(error)
            })
        }

        const handleMessage = (message,type) =>{
             $Vue.$message({ message, type, duration: 500 });
        }

        const approvalOpinionsCler = ()=>{
            approvalOpinionstextarea.value = ''
            ShowapprovalOpinions.value = false
            ShowDlong.value = true
            let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
            if(detailsInfo){
               form.student = detailsInfo.student
               form.student_s = detailsInfo.student_s
               form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
               form.dateTimeList = detailsInfo.dateTimeList
            }
        }

        const exportBtns = () =>{
            let data = {
                trainName: input1.value,
                teacher: coursecancellationStatusInput_ss.value,
                taskName: input2.value,
                auditId: student_s.value,
                auditStatus: coursecancellationStatusInput_s.value,
                teacherPerformance: coursecancellationStatusInput_sss.value,
            }
            axios.post(`${apiBaseUrl}/trainTask/exportTrainTaskAudit`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "审批管理.xlsx"; 
                    downloadLink.click();
                    handleMessage('导出成功', 'success')
                }
                else{
                    handleMessage('导出失败', 'error')
                }
            })
        }
        const searchBtns = () =>{
                handleInit()
        }
        const clearBtns = () =>{
            input1.value = ""
            input2.value = ""
            coursecancellationStatusInput_s.value = ""
            coursecancellationStatusInput_ss.value = ""
            student_s.value = ""
            coursecancellationStatusInput_sss.value = ""
            handleInit()
        }
        const addBtns = () =>{
            AddShowDlong.value = true
        }

        const handleSizeChange = (size) =>{
            requestParameters.pageSize = size
            let data = { 
                pageNum: requestParameters.pageNum,
                pageSize: requestParameters.pageSize,
                trainName: input1.value,
                teacher: coursecancellationStatusInput_ss.value,
                taskName: input2.value,
                auditId: student_s.value,
                auditStatus: coursecancellationStatusInput_s.value,
                teacherPerformance: coursecancellationStatusInput_sss.value,
            }
            axios.post(`${apiBaseUrl}/trainTask/findAuditPage`, data,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })
        }
        const handleCurrentChange = (page) =>{
            requestParameters.pageNum = page
            let data = { 
                pageNum: requestParameters.pageNum,
                pageSize: requestParameters.pageSize,
                trainName: input1.value,
                teacher: coursecancellationStatusInput_ss.value,
                taskName: input2.value,
                auditId: student_s.value,
                auditStatus: coursecancellationStatusInput_s.value,
                teacherPerformance: coursecancellationStatusInput_sss.value,
            }
            axios.post(`${apiBaseUrl}/trainTask/findAuditPage`, data,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })
        }

        const handleClickView = (boom, edible)=>{
            let { courseDate, courseEndTime, courseStartTime, subjectName } = edible
            form.student = courseStartTime
            form.student_s = courseEndTime
            form.coursecancellationStatusInput = subjectName
            form.dateTimeList = courseDate
            ShowDlong.value = true
            sessionStorage.setItem('detailsInfo',JSON.stringify(form))
            if(boom === '编辑'){
                ShowDlongDisabled.value = false
                ShowDlongTitle.value = '编辑'
            }
            if(boom === '详情'){

                resData.trainName = edible.trainName
                resData.teacherName = edible.teacherName
                resData.taskData = JSON.parse(edible.taskData)
                resData.createTime = edible.createTime
                resData.teacherId = edible.teacherId
                resData.taskName = edible.taskName
                resData.summarize = edible.summarize
                resData.auditData = JSON.parse(edible.auditData)
                resData.cancelCause = edible.cancelCause
                resData.auditStatus = edible.auditStatus
                resData.auditOpinion = edible.auditOpinion

                taskId.value = edible.taskId
                ShowDlongDisabled.value = true
                ShowDlongTitle.value = '方案任务详情'

            }
        }


        const commitCler = () =>{
            ShowDlong.value = false
            sessionStorage.setItem('detailsInfo',JSON.stringify(null))
            handleClrAll()
        }

        const commitAdd = (boomm) =>{
            if(boomm === 'No'){
                valueAuditStatus.value = -1
                ShowapprovalOpinions.value = true
            }
            if(boomm === 'Yes'){
                // ShowapprovalOpinions_Yes.value = true

                valueAuditStatus.value = 1
                ShowapprovalOpinions.value = true
            }
            if(boomm === 'NotPassedes'){
                valueAuditStatus.value = 2
                ShowapprovalOpinions.value = true
            }
            ShowDlong.value = false
            handleClrAll()
        }

        const handleClrAll = () =>{
            form.student = ""
            form.student_s = ""
            form.coursecancellationStatusInput = []
            form.dateTimeList = ""
        }

        const AddcommitCler = () =>{
            AddShowDlong.value = false
            handleClerAllDing()
        }

        const AddcommitAdd = () =>{
            console.log(Addform, 'Addform')
            console.log(fileDataList.value, 'fileDataList')


            AddShowDlong.value = false
            // setTimeout(()=>{
            //     handleClerAllDing()
            // },2000)
        }

        const AddcommitSub = () =>{
            console.log(Addform, 'Addform')
            console.log(fileDataList.value, 'fileDataList')


            AddShowDlong.value = false
            // setTimeout(()=>{
            //     handleClerAllDing()
            // },2000)
        }

        const handleClerAllDing = () =>{
            fileDataList.value = []
            Addform.TrainName = ""
            Addform.CreatorName = ""
            Addform.TrainerName = ""
            Addform.TrainingContent = ""
            Addform.ApprovedName = ""
        }

        const clickitem = (itme) =>{
            console.log(itme, 'itme')
        }

        const handleRemove = (file, fileList) =>{
            fileDataList.value = fileList
        }

        const getFileName = (name) => {
             return name.substring(name.lastIndexOf("."))
        }

        const beforeUpload = (file, fileList) =>{
            loadingUtils.startLoading()
            const fileExtensions =
                getFileName(file.name) === ".bmp" ||
                getFileName(file.name) === ".tif" ||
                getFileName(file.name) === ".gif" ||
                getFileName(file.name) === ".pcx" ||
                getFileName(file.name) === ".svg" ||
                getFileName(file.name) === ".psd" ||
                getFileName(file.name) === ".webp" ||
                getFileName(file.name) === ".apng" ||
                getFileName(file.name) === ".ai" ||
                getFileName(file.name) === ".avif" ||
                getFileName(file.name) === ".png" ||
                getFileName(file.name) === ".pdf"||
                getFileName(file.name) === ".mp4"||
                getFileName(file.name) === ".excel"||
                getFileName(file.name) === ".doc"||
                getFileName(file.name) === ".ppt"||
                getFileName(file.name) === ".mp3"||
                getFileName(file.name) === ".xls"||
                getFileName(file.name) === ".xlsx"||
                getFileName(file.name) === ".pptx"||
                getFileName(file.name) === ".docx"||
                getFileName(file.name) === ".txt"||
                getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                handleMessage("上传文件类不合格式!", 'warning')
            }
            if (!max20M) {
                handleMessage("上传文件类不合格式!", 'warning')
            }

            return fileExtensions && max20M
        }

        const handleUpload = (option) =>{
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = getFileNameUUID() + getFileName(option.file.name)
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()
                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        }

        const handleError = () =>{
            loadingUtils.endLoading()
        }


        const AddapprovalOpinions = () =>{
            let data = { auditStatus: valueAuditStatus.value, auditOpinion: approvalOpinionstextarea.value }
            axios.post(`${apiBaseUrl}/trainTask/auditTask/${taskId.value ? taskId.value : ''}`, data, {headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                //   isReturn(res.code)
                  if(res.data.code == 200){
                    ShowapprovalOpinions.value = false
                    approvalOpinionstextarea.value = ''
                    handleMessage('审批通过','success')
                    let data = { 
                        pageNum: requestParameters.pageNum,
                        pageSize: requestParameters.pageSize,
                        trainName: input1.value,
                        teacher: coursecancellationStatusInput_ss.value,
                        taskName: input2.value,
                        auditId: student_s.value,
                        auditStatus: coursecancellationStatusInput_s.value,
                        teacherPerformance: coursecancellationStatusInput_sss.value,
                    }
                    axios.post(`${apiBaseUrl}/trainTask/findAuditPage`, data,{
                        headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                    }).then(res => {
                        isReturn(res.code)
                        if(res.data.code == 200){
                            handleMessage("查询成功", 'success')
                        }
                        dataList.value = res.data.data.records
                        requestParameters.pageNum = res.data.data.current
                        requestParameters.pageSize = res.data.data.size
                        requestParameters.total = res.data.data.total

                    }).catch(error => {
                        console.error(error)
                    })
                  }
              }).catch(error => {
                console.error(error)
            })
        }

        const approvalOpinionsCler_Yes = () => {
            ShowapprovalOpinions_Yes.value = false
            ShowDlong.value = true
            let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
            if(detailsInfo){
               form.student = detailsInfo.student
               form.student_s = detailsInfo.student_s
               form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
               form.dateTimeList = detailsInfo.dateTimeList
            }
        }

        const AddapprovalOpinions_Yes = () => {
            let data = { auditStatus: 1, auditOpinion: ''}
            axios.post(`${apiBaseUrl}/trainTask/auditTask/${taskId.value ? taskId.value : ''}`, data, {headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.code == 200){
                    ShowapprovalOpinions_Yes.value = false
                    handleMessage('提交了通过','success')
                  }
              }).catch(error => {
                console.error(error)
            })
        }


        const commitCler_s = () =>{
            let data = { auditStatus: 2, auditOpinion: ''}
            axios.post(`${apiBaseUrl}/trainTask/auditTask/${taskId.value ? taskId.value : ''}`, data, {headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.code == 200){
                    ShowapprovalOpinions_Yes.value = false
                    handleMessage('提交了通过','success')
                  }
              }).catch(error => {
                console.error(error)
            })
        }


        return {
            handleUpload,
            beforeUpload,
            handleError,
            getFileName,
            handleRemove,
            handleClerAllDing,
            fileDataList,
            clickitem,
            AddcommitCler,
            AddcommitAdd,
            commitCler,
            commitAdd,
            handleMessage,
            getStudentsArr,
            getStudentsArr_s,
            taskId,
            coursecancellationStatus,
            coursecancellationStatusss,
            student,
            student_s,
            planArr,
            coursecancellationStatusInput,
            coursecancellationStatusInput_s,
            coursecancellationStatusInput_ss,
            dateTimeList,
            handleAllApi,
            exportBtns,
            searchBtns,
            clearBtns,
            addBtns,
            dataList,
            handleClickView,
            handleSizeChange,
            handleCurrentChange,
            requestParameters,
            ShowDlongTitle,
            ShowDlong,
            form,
            ShowDlongDisabled,
            handleClrAll,
            AddcommitSub,
            AddShowDlong,
            Addform,
            ShowapprovalOpinions,
            approvalOpinionsCler,
            approvalOpinionstextarea,
            AddapprovalOpinions,
            ShowapprovalOpinions_Yes,
            approvalOpinionsCler_Yes,
            AddapprovalOpinions_Yes,
            handleInit,
            coursecancellationStatuss,
            coursecancellationStatusInput_sss,
            input1,
            input2,
            resData,
            valueAuditStatus,
            commitCler_s,
        }

    }

})


</script>

<style scoped  lang="less">

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

/deep/ .el-upload{
    width: 100% !important;
}
/deep/ .el-form-item__label{
    text-align: start;
}

.disable-click {
   
   pointer-events: none;
 }
 

</style>


// WEBPACK FOOTER //
// src/initAssembly/ApprovalManagement.vue